// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"style_modal-header__Dd5hC"};